import { IProduct } from './ProductState';

export function isProductDesignEmpty(product: IProduct) {
  return product.sheets.every(($) => !$.layers.length);
}
